/**
 * @generated SignedSource<<dbd3f3eb3b7ac7d87edb78571dc15b87>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type getCachedPageDataSubTypePageTreeFragment$data = {
  readonly id: string;
  readonly subType: string | null | undefined;
  readonly " $fragmentType": "getCachedPageDataSubTypePageTreeFragment";
};
export type getCachedPageDataSubTypePageTreeFragment$key = {
  readonly " $data"?: getCachedPageDataSubTypePageTreeFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"getCachedPageDataSubTypePageTreeFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "getCachedPageDataSubTypePageTreeFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "kind": "ScalarField",
      "name": "subType"
    }
  ],
  "type": "PTPage"
};

(node as any).hash = "7ccb76f2a832d90b6f167fe96a11f5a9";

export default node;
